<template>
  <div class="achievement">
    <div class="content">
      <h2>主要成果内容</h2>
      <a-tabs default-active-key="1" class="tabs-content">
        <a-tab-pane key="1" tab="加速开发周期">
          <div class="card-box">
            <div class="card">
              <div class="title">加速开发周期</div>
              <p>本地化实验室进行硬件测试可以提前识别和解决问题，从而加速产品开发周期，使产品更快地推向市场。</p>
              <a-button class="btn-red" @click="$router.push('/activity/course')">免费学习</a-button>
            </div>
            <img src="@/assets/img/2.0/ecology/p1.png" alt="">
          </div>
        </a-tab-pane>
        <a-tab-pane key="2" tab="提高产品质量" force-render>
          <div class="card-box">
            <div class="card">
              <div class="title">提高产品质量</div>
              <p>通过全面的硬件测试，可以发现并解决与开源鸿蒙操作系统兼容性、性能问题以及硬件特定的错误和缺陷，有助于提高产品的质量，减少故障率。</p>
              <a-button class="btn-red" @click="$router.push('/activity/course')">免费学习</a-button>
            </div>
            <img src="@/assets/img/2.0/ecology/p2.png" alt="">
          </div>
        </a-tab-pane>
        <a-tab-pane key="3" tab="兼容性保证">
          <div class="card-box">
            <div class="card">
              <div class="title">兼容性保证</div>
              <p>开源鸿蒙操作系统的一个关键特点是其跨设备兼容性，开源鸿蒙创新实验室可以确保各种硬件设备上的应用程序和服务在开源鸿蒙上无缝衔接。</p>
              <a-button class="btn-red" @click="$router.push('/activity/course')">免费学习</a-button>
            </div>
            <img src="@/assets/img/2.0/ecology/p3.png" alt="">
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script>
export default{

}
</script>


<style scoped lang="scss">
.achievement{
  background: #FFF;
  .content{
    width: 1280px;
    margin: 0 auto;
    padding: 70px 0 64px;
    >h2{
      font-weight: 600;
      font-size: 32px;
      color: rgba(0,0,0,0.85);
      line-height: 44px;
      text-align: center;
      margin-bottom: 64px;
    }
    .tabs-content{
      ::v-deep .ant-tabs-nav-wrap{
        display: flex;
        align-items: center;
        justify-content: center;
        .ant-tabs-tab{
          padding: 1px 36px 26px;
          font-weight: 500;
          font-size: 18px;
          color: #262626;
          line-height: 24px;
        }
      }
      .card-box{
        height: 436px;
        position: relative;
        >img{
          position: absolute;
          right: 0;
          top: 48px;
          display: block;
          width: 690px;
          height: 388px;
          z-index: 1;
        }
        .card{
          position: absolute;
          left: 3px;
          top: 80px;
          width: 641px;
          height: 325px;
          background: #FFFFFF;
          box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.1);
          padding: 87px 40px;
          z-index: 10;
          .title{
            font-weight: 600;
            font-size: 22px;
            color: rgba(0,0,0,0.85);
            line-height: 30px;
          }
          >p{
            font-weight: 400;
            font-size: 14px;
            color: #666666;
            line-height: 16px;
            margin: 16px 0 40px;
          }
          .btn-red{
            width: 120px;
            height: 32px;
          }
        }
      }
    }
  }
}
</style>
